module.exports = __webpack_public_path__ + "img/gc2-min.jpg";